module.exports = __webpack_public_path__ + "fc6d4c754f.png";